import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalService } from '@common/services/modal.service';
import { DataService, TagRecord } from '@core/services/data.service';
import { TagsService } from '@core/services/tags.service';
import { SynchronizationService } from '@core/services/synchronization.service';
import { ApiService } from '@core/services/api.service';

@Component({
  templateUrl: './tag-editor.component.html',
  styleUrls: ['./tag-editor.component.scss']
})
export class TagEditorComponent implements OnInit {

  @Input()
  public tag: TagRecord;

  @Output()
  public change = new EventEmitter<TagRecord>();

  public error = false;

  constructor(private modal: ModalService, private ds: DataService, private ts: TagsService, private sync: SynchronizationService) { }

  public get loading(): boolean {
    return !this.sync.ready(ApiService);
  }

  public get empty(): boolean {
    return this.tag.Tag.trim().length == 0;
  }

  ngOnInit(): void {
  }

  public close() {
    this.modal.of(this).hide();
  }

  public save() {
    this.error = false;
    this.tag.Tag = this.tag.Tag.toUpperCase();

    this.ds.tags('update', this.tag).subscribe(tags => {
      if (tags && tags.length == 1 && tags[0].Tag == this.tag.Tag) {
        this.ts.synchronize();
        this.tag = tags[0];
        this.change.emit(this.tag);
        this.modal.of(this).hide();
      }
      else {
        this.error = true;
      }

    });
  }
}
